// PosUiIcon name for a caja payment-method bucket. Shared by every V2 money
// list (order payments box, caja movements) so a method always looks the same.
import { CajaPaymentMethod } from '@/interfaces/ICaja';

/** Methods with no caja bucket (unmapped/legacy gateways). */
export const PAYMENT_METHOD_FALLBACK_ICON = 'cash-multiple';

const PAYMENT_METHOD_ICONS: Record<CajaPaymentMethod, string> = {
  cash: 'cash',
  card: 'credit-card',
  online: 'web',
  qr: 'qrcode',
  banktransfer: 'bank-transfer',
  invitation: 'account',
  employee: 'account',
  customer: 'account',
  club: 'star-circle',
};

export function paymentMethodIcon(bucket: CajaPaymentMethod | null): string {
  return bucket ? PAYMENT_METHOD_ICONS[bucket] : PAYMENT_METHOD_FALLBACK_ICON;
}
